module.exports = __webpack_public_path__ + "static/media/vnaKa8X.018caf47.png";